export default {
    namespaced: true,
    state: {
        filtered: [],
        all: []
    },
    mutations: {
        SET_FILTERED(state, data) {
            state.filtered = data;
        },
        SET_PLAN_MODULES(state, modules) {
            state.all = modules;
            state.filtered = [...modules]; // Initialize filtered with all modules
        }
    },
    actions: {
        setPlanModules({ commit }, modules) {
            commit('SET_PLAN_MODULES', modules);
        },
        updateFiltered({ commit }, filtered) {
            commit('SET_FILTERED', filtered);
        }
    },
    getters: {
        getFiltered: state => state.filtered,
        getPlanModules: state => state.all
    }
}
